import { useCreate } from '@refinedev/core';
import { TemplateSectionCreationData } from 'src/company/templates/types';

type SplitMarkdownPayload = {
  templateMarkdown: string;
  populatedMarkdown: string;
  level: number;
};

export default function useSplitMarkdownMutation() {
  const { mutateAsync, error, isLoading, reset, data } = useCreate<TemplateSectionCreationData[]>();

  const splitMarkdown = async (values: SplitMarkdownPayload) => {
    const response = await mutateAsync({
      resource: 'admin/templates/split-markdown',
      values,
    });
    return response.data;
  };

  return {
    splitMarkdown,
    error,
    isLoading,
    reset,
    sections: data?.data,
  };
}
